import "../styles/360/application.scss";
import "../images/application";
import "@okta/okta-auth-js/polyfill";
import "../utils/reactRailsHelper";
